/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyerformata4landscape3Inputs */

const en_flyerformata4landscape3 = /** @type {(inputs: Flyerformata4landscape3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A4 landscape`)
};

const de_flyerformata4landscape3 = /** @type {(inputs: Flyerformata4landscape3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A4 Querformat`)
};

/**
* | output |
* | --- |
* | "A4 landscape" |
*
* @param {Flyerformata4landscape3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyerformata4landscape3 = /** @type {((inputs?: Flyerformata4landscape3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyerformata4landscape3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyerformata4landscape3(inputs)
	return de_flyerformata4landscape3(inputs)
});
export { flyerformata4landscape3 as "flyerFormatA4Landscape" }